export default __webpack_public_path__ + "static/media/desktop_mac.13e7079d.svg";